import moment from 'moment';
import { getSelectorList } from '@/pages/dashboard/services/funnel';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'umi';
import { formatSortFiltersData } from '../../utils/_config/formatSortFiltersData';
import { getSelectorSchemeList } from '../../services/dashboardSetting';
import { getFilterSaveListVal } from '../../utils/utils';

export const useFilterData = (pageType: string, path: string) => {
  const [loading, setLoading] = useState(true); // 筛选器loading
  const [selectorSchemeList, setSelectorSchemeList] = useState([]);
  const { currentGame, dataFrame } = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame,
      dataFrame: currentGame?.data_frame,
    };
  });

  const selectorRef = useRef<any>({
    gameCode: currentGame?.game_code
  });

  const getOutSelectorSchemeList = () => {
    getSelectorSchemeList(currentGame.game_code, path).then((res) => {
      setSelectorSchemeList(getFilterSaveListVal(res));
    });
  };

  // 初始化
  useEffect(() => {
    if (currentGame?.game_code) {
      Promise.all([getSelectorList({
        game_code: currentGame?.game_code,
        // selector_list:["country","area","channel", "lang","os","app_version","zone","network","memory","stage"],
        selector_list: dataFrame === 'casual' ? ['ab_test'] : [],
        platform: pageType,
        page: "register"
      }), getSelectorSchemeList(currentGame.game_code, path)]).then(([data, res]) => {
        const dataResult = formatSortFiltersData(data || {});
        selectorRef.current = {
          ...dataResult,
          gameCode: currentGame?.game_code,
          latestDate: {
            date: data?.last_date?.daily_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
            hour: data?.last_date?.hour_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
            week: data?.last_date?.weekly_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
            month: data?.last_date?.monthly_date || moment().subtract(1, 'day').format('YYYY-MM-DD'),
          }
        };
        setSelectorSchemeList(getFilterSaveListVal(res));
      }).catch((error)=>{
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [currentGame]);

  return {
    loading,
    selectorSchemeList,
    getOutSelectorSchemeList,
    selector: selectorRef.current
  };
};
